import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toTitleCase(str) {
  return str.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
  });
}

export function truncateHtmlContent(htmlContent, maxLines = 3) {
  const container = document.createElement("div");
  container.innerHTML = htmlContent;
  let textContent = container.textContent || container.innerText || "";

  // This is a very simplistic approximation and would need adjustment
  // based on your actual line length, font size, and container width.
  // You might need to experiment with these values.
  const approxLineLength = 100; // Adjust based on average characters per line
  const cutOffIndex = approxLineLength * maxLines;

  // Cutting off the text content to an approximation of three lines
  textContent = textContent.substring(0, cutOffIndex) + "...";

  // Returning the modified HTML. In a real-world scenario, you'd need
  // to re-insert HTML tags or handle them more gracefully.
  return textContent;
}
